import { Box } from "@mui/material";
import { AxiosError, AxiosResponse } from "axios";
import _ from "lodash";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { Input } from "src/components/common/FormComponents";
import ViewImages from "src/components/common/ViewImage";
import { PROJECT_DOCUMENT_TYPE_MAP, devTypes } from "src/constants/common";
import { CustomStyles, getStyles } from "src/styles/theme";
import { getMyProfileData, getProjectById } from "src/utils/api/dashboard";
import { getFormattedDate } from "src/utils/helper";
import defaultStyles, { StylesClasses } from "../../styles";
import { defaultForm } from "../defaultForm";
import { ActivityFormType } from "src/types/common";
import ProjectDetailSkeleton from "src/components/common/ProjectDetailSkeleton";

type WaterProjectProps = {
  projectId: string;
  customStyles?: CustomStyles<StylesClasses>;
};

const WaterDetails = ({ projectId, customStyles }: WaterProjectProps) => {
  const styles = getStyles<StylesClasses>(defaultStyles, customStyles);
  const [projectData, setProjectData] = useState<any>();
  const [documents, setDocuments] = useState<any>();

  const { isLoading } = useQuery(
    ["projects", projectId],
    () => getProjectById(projectId),
    {
      onSuccess: (res: AxiosResponse) => {
        setProjectData(res.data);
        const groupDocTypes = _.groupBy(res?.data?.documentDetail, "type");
        setDocuments(groupDocTypes);
      },
      onError: (err: AxiosError) => {
        setProjectData([]);
      },
      refetchOnMount: true,
    }
  );

  const userId = projectData?.organizationAffiliationDetail?.userId;

  const { data: userData } = useQuery(
    ["userDetails", userId],
    () => getMyProfileData(userId),
    {
      onSuccess: (res: AxiosResponse) => {},
      onError: (req: AxiosError) => {},
      enabled: !!userId,
    }
  );

  const { control, formState } = useForm<ActivityFormType>({
    defaultValues: { ...defaultForm },
  });
  const { errors } = formState;

  return (
    <Box>
      {!isLoading && !!projectData ? (
        <>
          <Box {...styles("projectName")}>
            Activity Registration No: {projectData?.registrationNo}
          </Box>
          <Box {...styles("userDetails")}>
            <Box {...styles("heading")}>
              {userData?.data?.userType === devTypes.ORGANIZATION
                ? "Entity Details"
                : "Individual Details"}
            </Box>
            <Box {...styles("container")}>
              <Box {...styles("input")}>
                <Input
                  name="userInfo.name"
                  label={
                    userData?.data?.userType === devTypes.ORGANIZATION
                      ? "Entity Name"
                      : "Name"
                  }
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={userData?.data?.firstName}
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="userInfo.email"
                  label="Email"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={userData?.data?.email}
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="userInfo.phoneNumber"
                  label="Phone Number"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={`${
                    !!userData?.data?.countryCode
                      ? userData?.data?.countryCode
                      : "+91"
                  } ${userData?.data?.phoneNumber}`}
                  control={control}
                />
              </Box>
              {/* <Box {...styles("input")}>
                <Input
                  name="userInfo.email"
                  label="Entity Name"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={userData?.data?.firstName}
                  control={control}
                />
              </Box> */}
              {userData?.data?.userType === devTypes.ORGANIZATION && (
                <>
                  <Box {...styles("input")}>
                    <Input
                      name="userInfo.email"
                      label="Entity Type"
                      placeholder=""
                      type="text"
                      readOnly={true}
                      value={userData?.data?.organizationType}
                      control={control}
                    />
                  </Box>
                  <Box {...styles("input")}>
                    <Input
                      name="activityDetails.organizationAffiliationDetail.industryTypeId"
                      label="Type of Industry"
                      placeholder=""
                      type="text"
                      readOnly={true}
                      value={
                        projectData?.organizationAffiliationDetail
                          ?.industryTypeName
                      }
                      control={control}
                    />
                  </Box>
                </>
              )}
            </Box>
          </Box>

          <Box {...styles("userDetails")}>
            <Box {...styles("heading")}>Activity Area Location Details</Box>
            <Box {...styles("container")}>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.address.addressLine1"
                  label="Address of the Plot"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={projectData?.address?.addressLine1}
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.address.state"
                  label="State"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={projectData?.address?.stateName}
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.address.district"
                  label="District"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={projectData?.address?.districtName}
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.address.city"
                  label="Village/City"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={projectData?.address?.city}
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.address.zipCode"
                  label="Pin Code"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={projectData?.address?.zipCode}
                  control={control}
                />
              </Box>
              <Box>
                {/* {projectData?.images?.map((item, idx) => {
              return (
                <Box>
                  <Box>
                    <ViewImages
                      key={item.imageUrl.fileUrl}
                      fileUrl={item.imageUrl.fileUrl}
                    />
                  </Box>
                  <Box>
                    <Box component="span">Latitude:</Box>
                    {item?.latitude}
                  </Box>
                  <Box>
                    <Box component="span">Longitude:</Box>
                    {item?.longitude}
                  </Box>
                </Box>
              );
            })} */}
              </Box>
            </Box>
          </Box>

          <Box {...styles("userDetails")}>
            <Box {...styles("heading")}>Plot/ Site/ Area Type Details</Box>
            <Box {...styles("container")}>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.landArea"
                  label="Site Area"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={`${projectData?.landArea}`}
                  control={control}
                  endAdornment={<Box>{`${projectData?.areaUnit}`}</Box>}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.landCategory"
                  label="Land Use Category"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={projectData?.landCategory}
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.landOwnershipType"
                  label="Ownership"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={projectData?.landOwnershipType}
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.rainfallZoneMultiplier"
                  label="RainFall Zone"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={projectData?.rainfallZoneMultiplier}
                  control={control}
                />
              </Box>
            </Box>
          </Box>

          <Box {...styles("userDetails")}>
            <Box {...styles("heading")}>Structure/ Activity DPR Details</Box>
            <Box {...styles("container")}>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.waterConservationDetail.structureTypeId"
                  label="Type of Structure"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={
                    projectData?.waterConservationDetail?.structureTypeName
                  }
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.projectStartDate"
                  label="Proposed Start Date"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={getFormattedDate(projectData?.projectStartDate)}
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.projectDuration"
                  label="Activity Duration"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={projectData?.projectDuration}
                  control={control}
                  endAdornment={<Box>Year</Box>}
                />
              </Box>

              <Box {...styles("input")}>
                <Input
                  name="activityDetails.waterConservationDetail.width"
                  label="Width of the Structure"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={`${projectData?.waterConservationDetail?.width}`}
                  control={control}
                  endAdornment={<Box>mtr</Box>}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.waterConservationDetail.length"
                  label="Length of the Structure"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={`${projectData?.waterConservationDetail?.length}`}
                  control={control}
                  endAdornment={<Box>mtr</Box>}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.waterConservationDetail.depth"
                  label="Depth of the Structure"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={`${projectData?.waterConservationDetail?.depth}`}
                  control={control}
                  endAdornment={<Box>mtr</Box>}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.waterConservationDetail.potentialCapacity"
                  label="Potential Capacity"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={
                    projectData?.waterConservationDetail?.potentialCapacity
                  }
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.waterConservationDetail.constructionStartDate"
                  label="Proposed Start Date of Construction"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={getFormattedDate(
                    projectData?.waterConservationDetail.constructionStartDate
                  )}
                  control={control}
                />
              </Box>
              <Box {...styles("input")}>
                <Input
                  name="activityDetails.waterConservationDetail.constructionDuration"
                  label="Duration of Construction"
                  placeholder=""
                  type="text"
                  readOnly={true}
                  value={projectData?.projectDuration}
                  control={control}
                  endAdornment={<Box>Year</Box>}
                />
              </Box>
            </Box>
          </Box>

          <Box {...styles("userDetails")}>
            <Box
              {...styles("heading", {
                marginBottom: "0px",
              })}
            >
              Issuance Schedule
            </Box>
            <Box {...styles("subHeading")}>
              Total Issuance during the life span
            </Box>
            <Box {...styles("container")}>
              {projectData?.provisionalDetails.map((provision, i) => {
                return (
                  <Box {...styles("input")}>
                    <Input
                      // customStyles={{
                      //   label: defaultStyles.label,
                      //   wrapper: defaultStyles.selectWrapper,
                      // }}
                      readOnly={true}
                      name={"userInfo.email"}
                      value={`${provision.percentage}%`}
                      control={control}
                      placeholder={`At the end of ${provision.year} year of plantation`}
                      type="text"
                      label={`At the end of ${provision.year} year of plantation`}
                    />
                  </Box>
                );
              })}
              <Box
                {...styles("heading", {
                  fontSize: "28px",
                  fontWeight: "600",
                  width: "100%",
                  mt: "10px",
                })}
              >
                Total Credits: {projectData?.estimatedCredits}
              </Box>
            </Box>
          </Box>

          <Box {...styles("imageWrapper")}>
            {projectData?.decelerations?.map((item) => (
              <ViewImages imageId={item.documentUrl} />
            ))}
          </Box>

          <Box>
            <Box {...styles("heading")}>Documents</Box>
            {Object.keys(documents)?.map((doc) => (
              <>
                <Box>{PROJECT_DOCUMENT_TYPE_MAP[doc]}</Box>
                <Box {...styles("documentGroup")}>
                  {documents[doc]?.map((item) => (
                    <ViewImages fileUrl={item.documentUrl.fileUrl} label={""} />
                  ))}
                </Box>
              </>
            ))}
          </Box>
        </>
      ) : (
        <ProjectDetailSkeleton />
      )}
    </Box>
  );
};

export default WaterDetails;
